import { navigations } from 'data/HeaderData'
import { useCallback, useEffect, useState } from 'react'
import _data from '../../../../../common/utils/_data'
import Project from '../../../../../common/project'
import { kebabCase } from 'lodash'

export const useHeaderMenuData = () => {
  const [menu, setMenu] = useState(navigations)
  const getDiscoverLaw = useCallback(() => {
    _data
      .get(`${Project.liveApi}law-categorisation/get-discover-law-data`)
      .then((data) => {
        const newDiscoverLaw = {
          name: 'Discover Law',
          url: '/discover-law',
          subs: data.map((parent) => [
            {
              name: parent.area.master_term,
              url: `/legal-field/${kebabCase(parent.area.master_term)}`,
              subs: [
                parent.subareas.map((child) => ({
                  name: child.master_term,
                  url: `/legal-sub-field/${kebabCase(child.master_term)}`,
                })),
              ],
            },
          ]),
        }
        const updatedMenu = navigations.map((item) =>
          item.name === 'Discover Law' ? newDiscoverLaw : item,
        )

        setMenu(updatedMenu)
      })
      .catch((error) => console.error(error))
  }, [])

  useEffect(() => {
    getDiscoverLaw()
  }, [getDiscoverLaw])

  return menu
}
